export default __webpack_public_path__ + "static/media/watchFrame.635dde19.png";